/**
 * 需要自动注册组件
 */

export default {}
